<nb-card class="dialog-card">
  <nb-card-header>
    <div class="dialog-title">
      <h4>{{ "pages.guardrails.historyTitle" | translate }}</h4>
      <p class="dialog-subtitle">{{ rule?.name }}</p>
    </div>
    <span *ngIf="truncated" class="truncation-note">
      {{
        "pages.guardrails.truncated"
          | translate: { shown: hits.length, total: total }
      }}
    </span>
  </nb-card-header>

  <nb-card-body>
    <app-page-loader *ngIf="isLoading"></app-page-loader>

    <p *ngIf="!isLoading && hits.length === 0" class="history-empty">
      {{ "pages.guardrails.historyEmpty" | translate }}
    </p>

    <!-- Shared table component: sorting, paging and the empty row come with it. -->
    <app-table
      *ngIf="!isLoading && hits.length > 0"
      rowIdKey="id"
      [title]="''"
      [columns]="columns"
      [data]="hits"
      [rowActions]="rowActions"
      [maxVisibleItems]="25"
      (event)="onTableEvent($event)"
    ></app-table>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton ghost size="small" (click)="close()">
      {{ "buttons.close" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
